import { createStore } from 'vuex';
import themeLayout from './modules/themeLayout/actionCreator';
import auth from './modules/authentication/axios/actionCreator';
import tasks from './modules/tasks/actionCreator';
import notes from './modules/notes/actionCreator';
import roles from './modules/roles/actionCreator';
import imports from './modules/import/actionCreator';
import users from './modules/users/actionCreator';
import contacts from './modules/contacts/actionCreator';
import tickets from './modules/tickets/actionCreator';
import events from './modules/events/actionCreator';
import campaigns from './modules/campaigns/actionCreator';
import packages from './modules/packages/actionCreator';
import profile from './modules/profile/actionCreator';
import permissions from './modules/permissions/actionCreator';
import labels from './modules/opportunities/actionCreator';
import dashboard from './modules/dashboard/actionCreator';
import forms from './modules/forms/actionCreator';
import register from './modules/register/actionCreator';
import confirmEmail from './modules/authentication/confirmEmail/actionCreator';
import segments from './modules/segments/actionCreator';

export default createStore({
  modules: {
    themeLayout,
    auth,
    tasks,
    notes,
    roles,
    users,
    contacts,
    tickets,
    events,
    campaigns,
    packages,
    profile,
    permissions,
    labels,
    dashboard,
    forms,
    imports,
    register,
    confirmEmail,
    segments,
  },
});
